import { ProfileKey, QueueKey } from './EntityKeys';

export type AutoReplyTemplateKey = `autoreplytemplate-${number}`;

export type AutoReplyTemplateMessageType = 'EMAIL' | 'WHATSAPP';

export const AUTO_REPLY_MESSAGE_TYPES: AutoReplyTemplateMessageType[] = [
    'EMAIL',
    'WHATSAPP',
];

export interface AutoReplyTemplateDTO {
    key: AutoReplyTemplateKey;
    queueEntityKey: QueueKey;
    profileEntityKey: ProfileKey;
    messageType: AutoReplyTemplateMessageType;
    messageTemplate: string;
}

export interface CreateAutoReplyTemplateDTO {
    queueEntityKey: QueueKey;
    profileEntityKey: ProfileKey;
    messageType: AutoReplyTemplateMessageType;
    messageTemplate: string;
}

export interface UpdateAutoReplyTemplateDTO {
    messageTemplate: string;
}
